import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { injectIntl } from "react-intl";
import confirmDelete from '../ConfirmDelete';
import ImgToolTip from '../ImgTooltip';

function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    }
    : null;
}

function calculateColorBasedOnBg(bg) {
  const rgb = hexToRgb(bg);
  return rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114 > 186
    ? "#000000"
    : "#FFFFFF";
}

const ThemeRow = ({ id, name, color, deleteFn, intl }) => {
  const delText = intl.formatMessage({id: 'confirm.s.color-delete'})

  return (
    <div className="added-event-container">
      <div className="e-name-container">
        <div className="e-name">
          <div className="event-icon-container color-container">
            <span style={{ backgroundColor: color, color: calculateColorBasedOnBg(color), padding: '5px 10px ' }}></span>
          </div>
          <div className="m-l-45 justify-content-center">
            <h6>
              {name}
            </h6>
          </div>
        </div>
        <div className="del-event-container justify-content-center">
          <Button
            onClick={() => {
              confirmDelete(intl, id, undefined, ('color', _id => (
                deleteFn('color', _id)
              )), delText);
            }}
          >
            <ImgToolTip className="icon-normal" intl={intl} placement="left" tooltiptext={`action.delete-theme`} id="tooltip-download-latest" img={`/icons/delete.png`} />
            <ImgToolTip className="icon-hover" intl={intl} placement="left" tooltiptext={`action.delete-theme`} id="tooltip-download-latest-hover" img={`/icons/delete-hover.png`} />
            <ImgToolTip className="icon-focus" intl={intl} placement="left" tooltiptext={`action.delete-theme`} id="tooltip-download-latest-focus" img={`/icons/delete-focus.png`} />
          </Button>
        </div>
      </div>
      <Link className="d-flex w-10" to={`/themes/edit/${id}`}>
        <Button className="btn-return">{intl.formatMessage({id: 'button.s.color-update'})}</Button>
      </Link>
    </div>
  );
};

export default injectIntl(ThemeRow);
